const jsonParse = ( s:string, defaultValue:Record<string,any> ) : Record<string,any> => {
    try {
        return JSON.parse(s);
    }
    catch( err ) {
        return defaultValue
    }
};

export default jsonParse;